function instructionsVideoData() {
  return {


    renderIframe: function(id) {
      // this is probably going away
       //console.log('video id:', id)
      return (
        `<iframe
          allowtransparency="true"
          class="replacementPdp-video-instruction-steps__video-iframe"
          src=https://www.youtube.com/embed/${id}
          srcdoc="
            <style>
              * {
                margin: 0;
                overflow: hidden;
                padding: 0;
              }
            
              html,
              body {
                height: 100%;
              }
            
              img,
              span {
                bottom: 0;
                margin: auto;
                position: absolute;
                top: 0;
                width: 100%;
              }
            
              span {
                color: white;
                font: 48px/1.5 sans-serif;
                height: 1.5em;
                text-align: center;
                text-shadow: 0 0 0.5em black;
              }
  
              a:focus img {
                outline: -webkit-focus-ring-color auto 5px;
              }
            </style>
  
            <a
              href='https://www.youtube.com/embed/${id}?autoplay=1'
              aria-label='Play installation video'
            >
              <picture>
                <source srcset='https://img.youtube.com/vi_webp/${id}/maxresdefault.webp' type='image/webp'>
                <source srcset='https://img.youtube.com/vi/${id}/maxresdefault.jpg' type='image/jpeg'> 
                <img src='https://img.youtube.com/vi/${id}/maxresdefault.jpg' alt=''>
              </picture>
              <span>▶</span>  
            </a>
          "
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
          title="Installation Video"
        >
        </iframe>
      `
    );
      
    },
  }
}